module.exports = __webpack_public_path__ + "img/img5.73a034c4.jpg";